<script setup lang="ts">
import { useAuthenticatedUserStore } from "@/modules/authentication/authentication-store";
import { onMounted } from "vue";

const store = useAuthenticatedUserStore();

onMounted(async () => {
  await store.userLogin("/");
});
</script>

<template>
  <div class="row">
    <div class="col">
      <h1>Du skickas nu vidare till inloggningen</h1>
    </div>
  </div>
</template>
